<!-- 按照精度：显示时，四舍五入；输入时，对小数部分进行截取 -->
<template>
  <el-input
    v-stopNumberMousewheel
    :value="toFormat(innerValue)"
    type="number"
    v-bind="$attrs"
    v-on="new$listeners"
  />
</template>

<script>
import { isNumber } from '@/utils/validate'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'NumInput',
  props: {
    value: { type: [Number, String], default: 0 },
    precision: { type: Number, default: -1 },
    truncatedPrecision: { type: Number, default: -1 }, // 截取精度，如果为无效值，取precision
    min: { type: Number, default: -Infinity },
    max: { type: Number, default: Infinity },
    round: { type: Boolean, default: false } // 四舍五入
  },
  data() {
    return {
      innerValue: this.toNumber(this.value)
    }
  },
  computed: {
    new$listeners() {
      return Object.assign(this.$listeners, { input: this.onInput, change: this.onChange, blur: this.onBlur })
    }
  },
  watch: {
    value() {
      this.innerValue = this.toNumber(this.value)
    },
    precision() {
      this.toFormat(this.innerValue)
    }
  },
  methods: {
    toNumber(val) {
      if (typeof val === 'string') {
        const num = Number(val)
        if (!isNaN(num)) {
          return num
        }
      }
      return val
    },
    toFormat(val) {
      if (this.precision >= 0 && typeof val === 'number' && !isNaN(val)) {
        return val.toFixed(this.precision)
      }
      return val
    },
    onInput(val) {
      // 非数字
      if (/[^0-9.]/.test(val)) {
        return
      }
      // indexOf、lastIndexOf的返回值分三种情况：
      // 1、没有“.”，都是-1（相等）
      // 2、有一个“.”，都是同一个值（相等）
      // 3、有两个及以上的“.”，值不一样（不相等）
      if (val.indexOf('.') !== val.lastIndexOf('.')) {
        return
      }
      this.innerValue = val
    },
    onChange(val) {
    },
    onBlur() {
      if (isNumber(this.innerValue)) {
        if (this.round) { // 四舍五入
          this.innerValue = Number(NumberUtils.ToFixed2(this.innerValue, this.precision))
        } else { // 直接截取
          this.innerValue = Number(NumberUtils.truncateDecimals(this.innerValue, this.truncatedPrecision >= 0 ? this.truncatedPrecision : this.precision))
        }
      } else {
        this.innerValue = 0
      }
      if (this.innerValue < this.min) {
        this.innerValue = this.min
      } else if (this.innerValue > this.max) {
        this.innerValue = this.max
      }
      this.$emit('input', this.innerValue)
      this.$emit('change', this.innerValue)
      this.$emit('blur')
    }
  }
}
</script>
